import { extractError, toCamel } from "@shared/utils";
import { CustomDataProvider, customFetch } from "./rest-data-provider";
import { createSharedConfigService } from "@shared/lib/config";

const dataProvider = (url: string): CustomDataProvider => ({
  custom: async ({ method, url: path, payload, headers, options }) => {
    const response = await customFetch(`${url}${path}`, {
      method,
      body: payload ? JSON.stringify(payload) : undefined,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...headers,
      },
      ...options,
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      const message = data?.message || (data.error ? extractError(data.error) : null) || response.statusText || "Unknown error";

      throw new Error(message);
    }

    return {
      data: toCamel(data),
    };
  },
});

export const createCmsDataProviderServer = () => {
  const configService = createSharedConfigService();

  return dataProvider(configService.config.cmsUrl || "http://localhost:8000");
}